export default __webpack_public_path__ + "static/media/checkbox-marked-circle.b20ba9da.svg";